module.exports = __webpack_public_path__ + "static/media/earth-2.d44c3040.jpg";